@if(isLoading){
<div class="loader-content d-flex flex-column justify-content-center">
  <app-loading [text]="'Loading...'"></app-loading>
</div>
} @else {
<div class="duplicate-wrapper d-flex h-100 flex-column">
  <div class="cluster-chart-wrapper">
    <span class="mb-2 accello-general-text17"
      >Duplicate Test Cases By Cluster</span
    >
    <app-bar-chart class="w-100 h-100" [data]="metric"></app-bar-chart>
  </div>
  <div class="d-flex justify-content-between mt-3">
    <span class="m-auto flex-grow-1 general-text-2">
      Select at least two test cases to view the comparison
    </span>
    <button
      (click)="compare()"
      class="btn-accello-secondary btn-accello d-flex p-1 px-2 mx-auto justify-content-center"
    >
      Compare
    </button>
  </div>
  <div class="cluster-wrapper align-items-center mt-3 d-flex">
    <span>Cluster ID</span>
    <select
      class="form-select"
      [(ngModel)]="selectedClusterId"
      (change)="onClusterIdChange()"
    >
      <option [value]="testCase.clusterId" *ngFor="let testCase of testArray">
        {{ testCase.clusterId }}. {{ testCase.topKeywords }}
      </option>
    </select>
  </div>
  <div *ngIf="filteredTestArray?.length" class="col-md-12">
    <!-- <app-zorro-table
      [columns]="clusterTableColumns"
      [data]="filteredTestArray"
      (onRowSelect)="handleRowSelection($event)"
      class="w-100"
    ></app-zorro-table> -->
    
    <app-tco-table [dataList]="filteredTestArray" [source]="'duplicate'" [resetSelection]="resetTableSelection" [uniqueFromDuplicateIds]="uniqueFromDuplicateIds" (onRowSelect)="handleRowSelection($event)"></app-tco-table>

  </div>
  <div class="mb-2">
    <!-- <p style="font-size: 19px">Test Case Comparison</p> -->
    <p class="cluster-component py-2">
     <strong> Test Case Comparison - {{ this.selectedClusterTopKeywords }} </strong>
    </p>

    <div class="test-comp" style="width: auto">
      <div class="outer-container" style="overflow-x: auto">
        <div class="selected-cards d-flex">
          <div
            *ngFor="let selectedTest of this.selectedTestCases; let i = index"
          >
            <div class="card card-illustrate" [ngStyle]="{ 'background': getColor(i).bg, 'border-color': getColor(i).border }">
              <!-- <h5 class="test-id p-2" style="text-align: center">
                Test ID: {{ selectedTest.testId }}
              </h5> -->
              <div class="p-2">
                <div class="d-flex flex-column">
                  <strong> Test ID: </strong>
                  <strong> {{ selectedTest.testId }} </strong>
                </div>

                <div class="d-flex flex-column mt-2">
                  <strong>Test Case Name</strong>
                  <span> {{ selectedTest.testName }} </span>
                </div>

                <div class="d-flex flex-column mt-2">
                  <strong> Test Description</strong>
                </div>

                <ng-container
                  *ngFor="
                    let word of selectedTest.description.split(' ');
                    let j = index
                  "
                >
                  <span
                    [style.backgroundColor]="
                      highlightTestDesc(selectedTest, j)
                        ? getHighlightColor(i)
                        : 'transparent'
                    "
                  >
                    {{ word }}
                  </span>

                  <span
                    *ngIf="j < selectedTest.description.split(' ').length - 1"
                  >
                  </span>
                </ng-container>

                <div><strong> Step Description</strong></div>
                <div
                  *ngIf="
                    selectedTest.formattedCorStepDesc &&
                    selectedTest.formattedCorStepDesc.length
                  "
                >
                  <div
                    class="step"
                    *ngFor="
                      let step of selectedTest.formattedCorStepDesc;
                      let x = index
                    "
                  >
                    <ng-container
                      *ngFor="let word of step.split(' '); let j = index"
                    >
                      <span
                        [style.backgroundColor]="
                          highlightFormattedStepDesc(selectedTest, j, x)
                            ? getHighlightColor(i)
                            : 'transparent'
                        "
                      >
                        {{ word }}
                      </span>

                      <span
                        *ngIf="
                          j < selectedTest.description.split(' ').length - 1
                        "
                      >
                      </span>
                    </ng-container>
                  </div>
                </div>

                <div><strong>Expected Results</strong></div>

                <ng-container
                  *ngFor="
                    let word of selectedTest.cleanedExpResult.split(' ');
                    let j = index
                  "
                >
                  <span
                    [style.backgroundColor]="
                      highlightExpectResult(selectedTest, j)
                        ? getHighlightColor(i)
                        : 'transparent'
                    "
                  >
                    {{ word }}
                  </span>
                  <span
                    *ngIf="
                      j < selectedTest.cleanedExpResult.split(' ').length - 1
                    "
                  >
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="this.selectedTestCases.length > 1" class="note p-3 mt-2 rounded-1">
      <span class="mt-4">
        <img src="assets/images/virtusa-icons/blue-square.svg" alt="blue">
        Indicates differences in wording between the two cases.
      </span>
    </div>
  </div>
  <div class="footer d-flex justify-content-end">
    <button class="btn-accello-primary-outlined align-items-center mx-2" (click)="goBack()">Back</button>
  </div>
</div>
}
